const TableHelpers = {
  CONFIG_COLUMNS: {
    headerStyle: {
      textAlign: 'center',
    },
    style: {
      textAlign: 'center',
    }
  }
}

export {
  TableHelpers
}